import axios from "axios";
import useAuthStore from "../store/Auth";

export const refreshAuthToken = async (): Promise<string> => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const refreshUrl = `${baseUrl}/api/Auth/RefreshToken`;

  const refreshRes = await axios.post(refreshUrl, null, {
    withCredentials: true,
  });

  const refreshedToken = refreshRes?.data?.result?.token;

  if (!refreshedToken) {
    throw new Error("Refresh token response did not include a token");
  }

  useAuthStore.setState({ token: refreshedToken });

  return refreshedToken;
};